import { makeStyles, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { LIST } from '../../../constants/props';

const useStyles = makeStyles({
  root: {
    width: '100%',
    padding: '1.5625rem 1.25rem',
  },
  title: {
    lineHeight: '1.75rem',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginBottom: '1.8125rem',
  },
});

const List = ({ title, list, item }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      {title && (
        <Typography className={classes.title} variant="button" component="h4">
          {title}
        </Typography>
      )}
      {Array.isArray(list) && list.map(item)}
    </Paper>
  );
};

List.propTypes = {
  LIST,
};

export default List;
